var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.445 4.96a1.877 1.877 0 000-2.653L17.678.54a1.877 1.877 0 00-2.654 0l-1.798 1.797 4.422 4.422zm-7.103-1.739L.74 14.821l-.732 4.197a.83.83 0 00.96.96l4.197-.736 11.599-11.6z"
  })));
}
export default SvgEdit;